import React, { useEffect, useState } from "react";
import { fetchReportTasks } from "../../../services/httpClient";
import { SingleCardMetric } from "../ui/SingleCardMetric";
import { formatDateTimeToLocal } from "../../../helpers/date";

interface TasksCompletedMetricState {
  data?: any[];
  readOnly?: boolean;
  setSelectedData: (data: any[] | null) => void;
  setDataHeaders: (data: any[] | null) => void;
  active?: boolean;
  useDatePicker?: boolean;
  startDate?: string;
  endDate?: string;
  onHandleClick?: any;
}

export const TasksCompletedMetric = ({
  data,
  readOnly = true,
  setSelectedData,
  setDataHeaders,
  active,
  useDatePicker = false,
  startDate,
  endDate,
  onHandleClick,
}: TasksCompletedMetricState) => {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [completed, setCompleted] = useState<any[]>();

  const tableHeaders = [
    { label: "Case ID", key: "case_id", hide: true },
    { label: "Case", key: "case_name" },
    { label: "Goal ID", key: "id", hide: true },
    { label: "Goal", key: "goal_name" },
    { label: "Name", key: "goal_subject.name" },
    { label: "Completed", key: "cm_reviewed_at_formatted" },
  ];

  useEffect(() => {
    const fetchData = async () => {
      if (data || data === 0) {
        setCompleted(data);
        setIsLoading(false);
      } else {
        //default dates
        const starting = new Date();
        starting.setDate(starting.getDate() - 365);
        var start = starting.toISOString().slice(0, 10);
        var end = new Date().toISOString().slice(0, 10);
        if (useDatePicker) {
          start = startDate ?? start;
          end = endDate ?? end;
        }
        await getTaskData(start!, end!);
        setIsLoading(false);
      }
    };

    fetchData();
  }, [data, startDate, endDate]);

  const getTaskData = async (start: string, end: string) => {
    fetchReportTasks(start, end)
      .then((res: any) => {
        const data = res[0].data;
        data.forEach((task: any) => {
          if (task?.completed_at) {
            const localDateTime = formatDateTimeToLocal(task.cm_reviewed_at);
            task.cm_reviewed_at_formatted = localDateTime.date + " " + localDateTime.time;
          }
        });
        setCompleted(data);
      })
      .catch((err: any) => {
        console.log(err);
      });
  };

  const onViewDetails = () => {
    if (!active) {
      setSelectedData(completed || null);
    } else {
      setSelectedData(null);
    }

    setDataHeaders(tableHeaders);
    onHandleClick();
  };

  if (readOnly) {
    return <SingleCardMetric title={"Tasks Completed"} total={completed?.length} isLoading={isLoading} />;
  } else {
    return (
      <SingleCardMetric
        title={"Tasks Completed"}
        total={completed?.length}
        onHandleClick={onViewDetails}
        cursor={true}
        active={active}
        isLoading={isLoading}
      />
    );
  }
};
